import { omit } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setReactiveSessionStorage } from 'global-actions';
import { selectors } from 'global-reducer';
function useSessionStorage(key) {
    const reactiveSessionStorage = useSelector(selectors.reactiveSessionStorage);
    const dispatch = useDispatch();
    const value = reactiveSessionStorage ? reactiveSessionStorage[key] : undefined;
    const setValue = (newValue) => {
        newValue && sessionStorage.setItem(key, newValue);
        dispatch(setReactiveSessionStorage({ ...reactiveSessionStorage, [key]: newValue }));
    };
    const resetValue = () => {
        dispatch(setReactiveSessionStorage(omit(reactiveSessionStorage, key)));
        sessionStorage.removeItem(key);
    };
    useEffect(() => {
        const sessionStorageValue = sessionStorage.getItem(key);
        setValue(sessionStorageValue || undefined);
    }, [value, dispatch, key]);
    return { value, setValue, resetValue };
}
export default useSessionStorage;
